import { withConfig } from "@/utils/withConfig";
import { ImpactCalculatorWithStore } from "./ImpactCalculatorWithStore";
import type { ImpactCalculatorWithStoreProps } from "./ImpactCalculatorProps";

export * from "./ImpactCalculator";
export * from "./ImpactCalculatorProps";
export * from "./ImpactCalculatorWithStore";

export const ImpactCalculatorWithConfig =
  withConfig<ImpactCalculatorWithStoreProps>(
    ImpactCalculatorWithStore,
    "impact_calculator",
  );
